import React from 'react';
import root from 'window-or-global';
import Message from '../../../../components/common/Message';
import themes from 'epic-diesel-common/src/constants/themes';
import {Button} from 'epic-diesel-common';
import {isPendingWalletStatus} from '../../../../utils/PayoutUtils';

//@ts-ignore
import styles from './HyperWallet.pcss';

export interface HyperWalletProps {
    taxState: any;
    traceSecurityLink: () => void;
    configState: any;
}

const HyperWallet: React.FC<HyperWalletProps> = ({
    taxState,
    configState,
    traceSecurityLink = () => {}
}) => {
    const {accountStatus, isConsent} = taxState || {};

    if (!isConsent || !isPendingWalletStatus(accountStatus)) {
        return null;
    }

    const handleClickActiveLink = (e?) => {
        const hyperWalletData = taxState.hyperWalletData || {};
        if (hyperWalletData.linkEnable) {
            root.open(hyperWalletData.link);
            traceSecurityLink();
        } else {
            root.open(configState.hyperWalletHomepage);
        }
    };

    return (
        <div className={styles.section}>
            <h2>
                <Message code="epic.affiliate.settings.tax.profile.secure.title.v2" />
            </h2>
            <Button theme={themes.DARK} onClick={handleClickActiveLink}>
                <Message code="epic.affiliate.settings.tax.profile.active.wallet.v2" />
            </Button>
        </div>
    );
};

export default HyperWallet;
